import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import moment from "moment";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const WeightChart = ({ weightData }) => {
  const data = {
    labels: weightData.map((d) => moment(d.date).format("D MMM")),
    datasets: [
      {
        label: "Weight",
        data: weightData.map((d) => d.val),
        backgroundColor: "#eb36c4ff",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.raw} Pounds`;
          },
        },
      },
    },
    scales: {
      x: { stacked: false, title: { display: true, text: "Date" } },
      y: {
        beginAtZero: true,
        title: { display: true, text: "Weight (Pounds)" },
      },
    },
  };

  return (
    <div className="card shadow-sm mb-4 h-full">
      <div className="card-header text-center text-xl font-bold text-gray-700">
        Weight Chart
      </div>
      <div className="card-body" style={{ height: "300px" }}>
        {weightData && weightData.length > 0 ? (
          <Bar data={data} options={options} />
        ) : (
          <p className="text-gray-500 font-semibold flex items-center justify-center h-full">
            No data found for selected criteria
          </p>
        )}
      </div>
    </div>
  );
};

export default WeightChart;
